import { busService, busServiceMain } from "../bus";
import { generateUUID } from "flavr-common";
import { CanvasTexture } from "three";
import { DestroyOffscreenMessage, OffscreenMessage, OffscreenTextureNeedsUpdateMessage } from "../../messages/offscreen/OffscreenMessages";
import { OffscreenRenderService } from "./OffscreenRenderImplService";
const OFFSCREEN_URI_PREFIX = "offscreen:";
class OffscreenService {
    constructor() {
        this.connection = busService.connection("OffscreenService");
        this.canvasMap = new Map();
        this.handleOffscreenTextureNeedsUpdateMessage = (msg) => {
            const data = this.canvasMap.get(msg.id);
            if (!data)
                return;
            if (!data.texture)
                return;
            data.texture.needsUpdate = true;
        };
        this.connection.subscribeByType(OffscreenTextureNeedsUpdateMessage, this.handleOffscreenTextureNeedsUpdateMessage);
    }
    checkUri(uri) {
        if (!uri.startsWith(OFFSCREEN_URI_PREFIX))
            return undefined;
        return uri.substring(OFFSCREEN_URI_PREFIX.length);
    }
    createUri(id) {
        return `${OFFSCREEN_URI_PREFIX}${id}`;
    }
    getCanvasTexture(id) {
        const data = this.canvasMap.get(id);
        if (!data) {
            return undefined;
        }
        if (!data.texture) {
            data.texture = new CanvasTexture(data.canvas);
        }
        return data.texture;
    }
    create(rendererType, width, height) {
        const id = this.generateId();
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const data = {
            canvas
        };
        this.canvasMap.set(id, data);
        if (!("transferControlToOffscreen" in canvas)) {
            console.warn("transferControlToOffscreen is not supported");
            if (this.fallbackOffscreenRender === undefined) {
                this.fallbackOffscreenRender = new OffscreenRenderService();
                this.fallbackOffscreenRender.init();
            }
            this.connection.send(new OffscreenMessage(id, rendererType, canvas, width, height, window.devicePixelRatio));
            return id;
        }
        const offscreen = canvas.transferControlToOffscreen();
        busServiceMain.transferOffscreen("OffscreenService", id, rendererType, offscreen, canvas.width, canvas.height, window.devicePixelRatio);
        return id;
    }
    destroy(id) {
        const data = this.canvasMap.get(id);
        if (data == null)
            return;
        this.canvasMap.delete(id);
        this.connection.send(new DestroyOffscreenMessage(id));
        if (data.texture !== undefined) {
            data.texture.dispose();
        }
    }
    generateId() {
        let id = generateUUID();
        while (this.canvasMap.has(id)) {
            id = generateUUID();
        }
        return id;
    }
}
export const offscreenService = new OffscreenService();
